module.exports = __webpack_public_path__ + "img/dash-fiscal.ce71a740.svg";